import request from '@/utils/request'

export function getTicketPointListApi() {
  return request({
    url: '/config-ticket-service/v1/ticket-point',
    method: 'get'
  })
}
export function getTicketOfficeListApi() {
  return request({
    url: '/config-ticket-service/v1/ticket-office',
    method: 'get'
  })
}
export function getPromotionList(query) {
  return request({
    url: '/config-service/v1/promotion/promotion-system/list',
    method: 'get',
    params: query
  })
}
export function getPromotionDetail(promotionId) {
  return request({
    url: `/config-service/v1/promotion/promotion-system/list/${promotionId}`,
    method: 'get'
  })
}
export function createPromotion(data) {
  return request({
    url: '/config-service/v1/promotion/promotion-system/add',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
export function updatePromotion(data) {
  return request({
    url: '/config-service/v1/promotion/promotion-system/update',
    method: 'put',
    data
  })
}

export function createVoucher(data) {
  return request({
    url: '/config-service/v1/voucher/voucher-system/add',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
export function updateVoucher(data) {
  return request({
    url: '/config-service/v1/voucher/voucher-system/update',
    method: 'put',
    data
  })
}
export function getVoucherList(query) {
  return request({
    url: '/config-service/v1/voucher/voucher-system/list',
    method: 'get',
    params: query
  })
}
export function getVoucherDetail(id) {
  return request({
    url: `/config-service/v1/voucher/voucher-system/get/${id}`,
    method: 'get'
  })
}

export function checkVoucherApi(data) {
  return request({
    url: '/config-service/v1/voucher/voucher-system/check-voucher-pms',
    method: 'post',
    data: data
  })
}

export function checkPromotionApi(data) {
  return request({
    url: '/config-service/v1/promotion-new/promotion-system/check-promotion-pms',
    method: 'post',
    data: data
  })
}
// export function getApplyListByPromotion(promotionId) {
//   return request({
//     url: `/config-service/v1/promotion/promotion-system/list-apply-by-promotion/${promotionId}`,
//     method: 'get'
//   })
// }
export function deletePromotionList(data) {
  return request({
    url: '/config-service/v1/promotion/promotion-system',
    method: 'delete',
    data
  })
}

export function deleteVoucherList(data) {
  return request({
    url: '/config-service/v1/voucher/voucher-system',
    method: 'delete',
    data
  })
}

export function getListCodeBase(query) {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: query
  })
}
export function getTicketTypeApi() {
  return request({
    url: '/config-ticket-service/v1/ticket-type',
    method: 'get'
  })
}
export function getNoChildTicketApi() {
  return request({
    url: '/config-ticket-service/v1/ticket',
    method: 'get',
    params: {
      type: 0 // ve KO phan biet nguoi lon / tre em
    }
  })
}

export function getTicketListApi(query) {
  return request({
    url: '/config-ticket-service/v1/ticket',
    method: 'get',
    params: query
  })
}

/** pCode = PM_PMS
{
  "is_error": false,
  "data": [
    {
      "p_id": 480,
      "p_code": "PM_PMS",
      "p_desc": null,
      "id": 481,
      "code": "PM_PMS_01",
      "desc": "Nếu khách đến > 2 lần"
    },
    {
      "p_id": 480,
      "p_code": "PM_PMS",
      "p_desc": null,
      "id": 482,
      "code": "PM_PMS_02",
      "desc": "Nếu khách thuộc nhóm/ nguồn"
    },
    {
      "p_id": 480,
      "p_code": "PM_PMS",
      "p_desc": null,
      "id": 483,
      "code": "PM_PMS_03",
      "desc": "Nếu khách có ngày sinh nhật trong thời gian lưu trú"
    }
  ],
  "total": 3
}
 */

// ========== DEPRECATED ================= //
export function getPromotionListApi(query) {
  return request({
    url: '/booking-service/v1/promotion',
    method: 'get',
    params: query
  })
}
export function addPromotionApi(payload) {
  return request({
    url: '/booking-service/v1/promotion',
    method: 'post',
    data: payload
  })
}
export function updatePromotionApi(payload) {
  return request({
    url: '/booking-service/v1/promotion',
    method: 'put',
    data: payload
  })
}
export function deletePromotionApi(payload) {
  return request({
    url: '/booking-service/v1/promotion',
    method: 'delete',
    data: payload
  })
}

// ========== NEW PROMOTION API ================= //
export function getNewPromotionList(query) {
  return request({
    url: '/config-service/v1/promotion-new/promotion-system/list',
    method: 'get',
    params: query
  })
}

export function getNewPromotionDetail(promotionId) {
  return request({
    url: `/config-service/v1/promotion-new/promotion-system/get/${promotionId}`,
    method: 'get'
  })
}

export function createNewPromotion(data) {
  return request({
    url: '/config-service/v1/promotion-new/promotion-system/add',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function updateNewPromotion(data) {
  return request({
    url: '/config-service/v1/promotion-new/promotion-system/update',
    method: 'put',
    data
  })
}

export function deleteNewPromotionList(data) {
  return request({
    url: '/config-service/v1/promotion-new/promotion-system',
    method: 'delete',
    data
  })
}

export function exportVoucherTicket(voucherId) {
  return request({
    url: `/config-service/v1/voucher/voucher-system/export-voucher-ticket/${voucherId}`,
    method: 'get',
    responseType: 'blob'
  })
}

export function exportVoucherRoom(voucherId) {
  return request({
    url: `/config-service/v1/voucher/voucher-system/export-voucher-room/${voucherId}`,
    method: 'get',
    responseType: 'blob'
  })
}

